import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import styles from "./styles/Statements.module.css";
import clsx from "clsx";
import {
  Button,
  Dropdown,
  InputGroup,
  Form,
  Accordion,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import moment from "moment";
import { TableCustom } from "@components/TableCustom/TableCustom";
import { data } from "./DataStatements";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { InputField } from "@components/Input/InputField";
import { SelectField } from "@components/Input/SelectField";
import { getAllStatementsAction } from "@redux/actions";
import { Paginator } from "@components/Paginator/Paginator";

const pageSizeList = [
  { id: 5, name: "5" },
  { id: 10, name: "10" },
  { id: 20, name: "20" },
];
const orderByList = [
  { id: "asc", name: "ASC" },
  { id: "desc", name: "DESC" },
];

const validateSchema = Yup.object().shape({
  startDay: Yup.date(),
  endDate: Yup.date(),
  Orderby: Yup.string(),
  PageSize: Yup.number(),
});

const initialValues = {
  startDay: "",
  endDate: "",
  Orderby: "",
  PageSize: "",
};

const Statements = () => {
  // state
  const { profile } = useSelector((state) => state.user);
  const { allStatements } = useSelector((state) => state.balance);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  //   const [monthList, setMonthList] = useState([]);

  // variables
  console.log(allStatements.data);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => {
        return <span>{`${moment(date).format("DD MMM YYYY")}`}</span>;
      },
    },
    // {
    //   title: "Order Id",
    //   dataIndex: "orderId",
    // },
    {
      title: "Type",
      dataIndex: "type",
    },
    // {
    //   title: "Title",
    //   dataIndex: "title",
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amount) => {
        return <span>{`$${amount}`}</span>;
      },
    },
    // {
    //   title: "Fee",
    //   dataIndex: "fee",
    //   render: (fee) => {
    //     return <span>{`-$${fee}`}</span>;
    //   },
    // },
    // {
    //   title: "Title",
    //   dataIndex: "title",
    // },
  ];

  // logics before hooks

  // hooks
  //   const [width] = useWindowSize();

  // logics

  const callSubmit = () => {
    let data = {};
    if (values.Orderby) {
      data = { ...data, ...{ Orderby: values.Orderby } };
    }
    if (Number(searchParams.get("PageNumber"))) {
      data = {
        ...data,
        ...{
          PageNumber: Number(searchParams.get("PageNumber")),
        },
      };
    }
    if (values.PageSize) {
      data = {
        ...data,
        ...{
          PageSize: values.PageSize,
        },
      };
    }
    if (values.startDay) {
      data = { ...data, ...{ startDay: values.startDay } };
    }
    if (values.endDate) {
      data = { ...data, ...{ endDate: values.endDate } };
    }

    dispatch(getAllStatementsAction(data));
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    // setFieldError,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: () => {
      searchParams.set("PageNumber", 1);
      setSearchParams(searchParams, { replace: true });
      callSubmit();
    },
  });

  // UI partials

  // effects

  useEffect(() => {
    callSubmit();
  }, [dispatch, searchParams]);

  // render
  return (
    <div className={clsx(styles.container)}>
      <div className={clsx(styles.header)}>
        <i className="bi bi-file-earmark-text" />
        Statements
      </div>
      <div className={clsx(styles.contentContainer)}>
        <div className={clsx(styles.overviewContainer)}>
          <div className={clsx(styles.card, styles.earningsCard)}>
            <span className={clsx(styles.titleCard)}>Earnings</span>
            <hr />
            <span className={clsx(styles.itemText)}>
              Your sales earnings over the last 30 days
            </span>
            <div className={clsx(styles.overviewParameters)}>
              <div className={clsx(styles.overviewItem)}>
                <span className={clsx(styles.itemText)}>My funds</span>
                <span
                  className={clsx(styles.detailText)}
                  style={{ color: "black" }}
                >
                  {"$289.64"}
                </span>
              </div>
              <div className={clsx(styles.overviewItem)}>
                <span className={clsx(styles.itemText)}>Earnings</span>
                <span
                  className={clsx(styles.detailText)}
                  style={{ color: "#82b541" }}
                >
                  {"+ $458.00"}
                </span>
              </div>
              <div className={clsx(styles.overviewItem)}>
                <span className={clsx(styles.itemText)}>Edututs+ Fees</span>
                <span
                  className={clsx(styles.detailText)}
                  style={{ color: "#ed2a26" }}
                >
                  {"- $154.86"}
                </span>
              </div>
            </div>
          </div>
          {/* <div className={clsx(styles.card, styles.invoicesCard)}>
            <span className={clsx(styles.titleCard)}>View Invoices</span>
            <hr />
            <div className={clsx(styles.selectContainer)}>
              <Dropdown className={clsx(styles.dropdownContainer)}>
                <Dropdown.Toggle
                  className={clsx(styles.dropdownMonth)}
                  variant="success"
                  id="dropdown-basic"
                  aria-expanded={false}
                >
                  {monthInvoices
                    ? monthList.filter((value) => value.id === monthInvoices)[0]
                        .name
                    : "Monthly Invoices"}
                </Dropdown.Toggle>

                <Dropdown.Menu className={clsx(styles.dropdownMenu)}>
                  {monthList.map((value, key) => {
                    return (
                      <Dropdown.Item
                        key={key}
                        value={value.id}
                        onClick={() => {
                          setMonthInvoices(value.id);
                        }}
                      >
                        {value.name}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
              <Button>
                <i className="bi bi-box-arrow-in-down" />
              </Button>
            </div>
          </div> */}
        </div>
        <div className={clsx(styles.detailContainer)}>
          <Accordion className={styles.newDiscountContainer}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filter</Accordion.Header>
              <Accordion.Body>
                <Form
                  noValidate
                  onSubmit={handleSubmit}
                  className={styles.formContainer}
                >
                  <Row className="g-4">
                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="startDay">
                        <Form.Label>Start Date*</Form.Label>
                        <InputField
                          name={"startDay"}
                          type={"datetime-local"}
                          // placeholder="Select start date"
                          placeholder="dd-mm-yyyy"
                          value={values.startDay}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          touchedValue={touched.startDay}
                          errorsValue={errors.startDay}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="endDate">
                        <Form.Label>End Date*</Form.Label>
                        <InputField
                          name={"endDate"}
                          type={"datetime-local"}
                          placeholder="dd-mm-yyyy"
                          value={values.endDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          touchedValue={touched.endDate}
                          errorsValue={errors.endDate}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="PageSize">
                        <Form.Label>Page Size*</Form.Label>
                        <SelectField
                          name={"PageSize"}
                          value={values.PageSize || ""}
                          onChange={(val) => setFieldValue("PageSize", val)}
                          listValue={pageSizeList}
                          isLoading={false}
                          placeholder={"Select Page Size"}
                          error={errors.PageSize}
                          setFieldError={() => {}}
                          touched={touched.PageSize}
                          setFieldTouched={() => {
                            setFieldTouched("PageSize", true);
                          }}
                          multiple={false}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={5} md={6}>
                      <Form.Group className="px-0 mb-4" controlId="Orderby">
                        <Form.Label>Order By*</Form.Label>
                        <SelectField
                          name={"Orderby"}
                          value={values.Orderby || ""}
                          onChange={(val) => setFieldValue("Orderby", val)}
                          listValue={orderByList}
                          isLoading={false}
                          placeholder={"Order by"}
                          error={errors.Orderby}
                          setFieldError={() => {}}
                          touched={touched.Orderby}
                          setFieldTouched={() => {
                            setFieldTouched("Orderby", true);
                          }}
                          multiple={false}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Button
                        type="submit"
                        className={styles.btnSave}
                        disabled={allStatements.processing}
                      >
                        <div className={clsx(styles.btnContent)}>
                          {allStatements.processing ? (
                            <Spinner
                              animation="border"
                              role="status"
                              className="text-center"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </Spinner>
                          ) : null}
                          <span>Apply</span>
                        </div>
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <TableCustom
            className={clsx(styles.card)}
            columns={columns}
            dataSource={data}
            isLoading={false}
          />
          <div className={clsx(styles.pagination)}>
            {allStatements.pagination ? (
              <Paginator data={allStatements.pagination} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

/* required: display name */
Statements.displayName = "Statements";

/* required: props types */
Statements.propTypes = {};

/* required: default props */
Statements.defaultProps = {};

export { Statements };
